import { Body1, Button, Heading1, useDeviceType } from '@cian/ui-kit';
import cn from 'clsx';
import React from 'react';
import { ETestIds } from 'shared/constants/testIds';
import { useResetCalculatorFilters } from 'shared/hooks/useResetCalculatorFilters';

import styles from './styles.css';

export const ShortOffersEmpty: React.FC = () => {
  const deviceType = useDeviceType();
  const isPhone = deviceType === 'phone';
  const handleResetFilters = useResetCalculatorFilters();

  return (
    <div className={cn(styles['root'], styles[deviceType])} data-testid={ETestIds.ShortOffersEmpty}>
      <Heading1 fontWeight="700">Нет подходящих предложений</Heading1>
      <Body1 color="text-secondary-default">Измените срок кредита или первый взнос</Body1>
      <Button
        size="L"
        fullWidth={isPhone}
        onClick={handleResetFilters}
        data-testid={ETestIds.ShortOffersResetFiltersButton}
      >
        Сбросить фильтры
      </Button>
    </div>
  );
};
